var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row", attrs: { id: "title" } }, [
      _c("div", { staticClass: "col-1" }, [
        _c(
          "svg",
          {
            staticClass: "bd-placeholder-img mr-2 rouded",
            attrs: {
              id: "header",
              width: "28",
              height: "28",
              xmlns: "http://www.w3.org/2000/svg",
              preserveAspectRatio: "xMidYMid slice",
              focusable: "false",
              role: "img",
              "aria-lavel": "Placeholder: 32x32",
            },
          },
          [
            _c("rect", {
              attrs: { width: "100%", height: "100%", fill: "#00C3E0" },
            }),
          ]
        ),
      ]),
      _vm._m(0),
      _c("div", { staticClass: "col-3" }, [
        _c(
          "button",
          {
            staticClass: "btn-sm btn-outline-info",
            attrs: { id: "backBtn", type: "button" },
            on: { click: _vm.back },
          },
          [_vm._v("キャンセルする")]
        ),
      ]),
      _c("div", { staticClass: "col-3" }, [
        _c(
          "button",
          {
            staticClass: "btn-sm btn-outline-primary",
            attrs: { type: "button" },
            on: { click: _vm.download },
          },
          [_vm._v("フォーマットを出力する")]
        ),
      ]),
    ]),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-4" }, [
        _c("label", [_vm._v("操作を選択してください")]),
        _c(
          "select",
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.current,
                expression: "current",
              },
            ],
            staticClass: "form-control",
            on: {
              change: function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.current = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
            },
          },
          [
            _c("option", { attrs: { value: "1" } }, [
              _vm._v("連絡先を作成する"),
            ]),
            _c(
              "option",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.$store.state.contact.extraContactId !== 0,
                    expression: "$store.state.contact.extraContactId !== 0",
                  },
                ],
                attrs: { value: "3" },
              },
              [_vm._v("連絡先を削除する")]
            ),
            _c("option", { attrs: { value: "2" } }, [
              _vm._v("連絡先とグループの紐づけを登録・更新する"),
            ]),
          ]
        ),
      ]),
    ]),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.current === "2",
            expression: "current === '2'",
          },
        ],
        staticClass: "row pt-2",
      },
      [
        _c("div", { staticClass: "col-1" }),
        _c("div", { staticClass: "col-11" }, [
          _c("p", { staticClass: "m-0", staticStyle: { color: "red" } }, [
            _vm._v(_vm._s(_vm.importConnectionNote)),
          ]),
        ]),
      ]
    ),
    _c("div", { staticClass: "row py-2" }, [
      _c("div", { staticClass: "col-1" }),
      _c("div", { staticClass: "col-11" }, [
        _c(
          "form",
          {
            attrs: { enctype: "multipart/form-data" },
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.upload.apply(null, arguments)
              },
            },
          },
          [
            _c("input", {
              ref: "file",
              attrs: { type: "file", name: "csvfile" },
              on: { change: _vm.selectedFile },
            }),
            _c("button", { staticClass: "btn btn-info" }, [_vm._v("Upload")]),
          ]
        ),
      ]),
    ]),
    _c("p", [_vm._v(_vm._s(_vm.message))]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-5" }, [
      _c("h5", [_vm._v("import CSV")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }